const React = require('react');
const classNames = require('classnames');
const Spinner = require('./spinner.jsx');
const ErrorMessage = require('./error_message.jsx');

class LoadingOverlay extends React.Component {
  static defaultProps = {
    showOverlay: false,
  };

  activeClass = () => {
    return this.props.showOverlay ? 'loading-overlay-container--active' : '';
  };

  spinner = () => {
    if (this.props.showOverlay) {
      return (
        <Spinner size={this.props.size} color={this.props.color} />
      );
    }
  };

  render() {
    return (
      <div className={classNames('loading-overlay-container', this.activeClass())}>
        {this.spinner()}
        <div className="loading-overlay-content">
          {this.props.children}
        </div>
      </div>
    );
  }
}

module.exports = LoadingOverlay;



// WEBPACK FOOTER //
// ./javascripts/components/shared/loading_overlay.jsx